import { Component, OnInit, Input } from '@angular/core';
import {ResumeService} from "../resume/resume.service";
import {FireService} from '../../fire.service';
import {Resume} from "../../models/resume";

@Component({
  selector: 'app-resume-item',
  templateUrl: './resume-item.component.html',
  styleUrls: ['./resume-item.component.css'],
  providers: [ResumeService]
})
export class ResumeItemComponent implements OnInit {

  @Input() step: string;
  @Input() type: string;

  data: Resume = {
    title: '',
    description: '',
    milestones: undefined
  };
  private _date;

  constructor(private resumeService: ResumeService, private fireService: FireService) { }

  ngOnInit() {
    this._date = new Date();
  }

  getData() {
    if(this.data['milestones']) {
      // do not make a HTTP call if there is already data
      return;
    }
    switch(this.type) {
      case 'education':
        this.fireService.getEducationDetails(items => {
          this.data = items;
          this.data.milestones = items[1].sort((a, b) => a.id < b.id);
        });
        break;
      case 'experience':
        this.fireService.getExperienceDetails(items => {
          this.data = items;
          this.data.milestones = items[1].sort((a, b) => a.id < b.id);
        });
        break;
      default:
        this.data['error'] = 'could not get the data'
    }
  }

  getTimeSpanned(m) {
    const year = m.year;
    let _year = this._date.getFullYear() - +(year);
    if(_year > 1) {
      return `been ${_year} yrs`;
    } else if(_year == 1) {
      return `around a year`;
    } else {
      return 'been few months';
    }
  }
}



// WEBPACK FOOTER //
// F:/Home/Locker/About-me/about-me1/src/app/displayer/resume-item/resume-item.component.ts